// 业务用户相关工具
import validate from '@/config/validate';
import { Toast } from 'vant';
import { eventTrack, eventTrackExtra } from '@/api/user'
import { getStorage } from '@/libs/utils';

// 头条上报金额转化 旧项目搬过来的
export const handleThirdLib = (price, thirdLibs) => {
  if (thirdLibs == '') {
    return false;
  } else {
    if (thirdLibs[0].price_scope == '') {
      return false;
    } else {
      const price_scope = JSON.parse(thirdLibs[0].price_scope);
      for (let i in price_scope) {
        let len = i.split('-');
        if (price > parseInt(len[0]) && price <= parseInt(len[1])) {
          if (price_scope[i] > 1 || price_scope[i] == 1) {
            price = parseFloat(price_scope[i]);
            return price;
          } else {
            price = parseFloat(price_scope[i]) * price;
            return price;
          }
        }
      }
    }
  }
};

// 针对表单进行正则验证
/**
 *
 * @param {Object} form 需要提交的表单
 * @param {key.字段名, type.验证类型, hint.错误提示} mode 表单中每个字段对应的正则类型，错误提示
 * @returns {true.验证成功 false.验证失败}
 */
export const regexpVerify = (form, mode) => {
  return new Promise((resolve, reject) => {
    mode.map(item => {
      if (!form[item.key]) {
        Toast(item.hint);
        reject();
      }
      if (item.type) {
        let reg = new RegExp(validate[item.type]);
        if (!reg.test(form[item.key])) {
          Toast(item.hint);
          reject();
        }
      }
    });
    resolve(null);
  });
};

export const buryReport = (type) => {
  const user_id = getStorage('user_id');
  const appkey = getStorage('appkey');
  const device_info = getStorage('device_info');
  eventTrack({
    appkey: appkey,
    event: type,
    device_id: device_info.device_id,
    os: device_info.os,
    user_id: user_id
  })
}

export const buryReportV2 = (type, extra_data) => {
  const user_id = getStorage('user_id');
  const appkey = getStorage('appkey');
  const device_info = getStorage('device_info');
  const extraData = JSON.parse(getStorage('extra_data'));
  eventTrackExtra({
    appkey: appkey,
    event: type,
    device_id: device_info.device_id, 
    device_name: device_info.device_name,
    system_version: extraData.system_version,
    extra_data: extra_data || {},
    os: device_info.os,
    user_id: user_id,
    client_extra_data: getStorage('extra_data'),
  })
}